export default {
  home: "Tutellus — Home",
  tagline: "We improve the world with tokenized businesses.",
  sections: {
    emprende: "Build",
    invierte: "Invest",
    ecosistema: "Ecosystem",
  },
  links: {
    tok120: "TOK120 Program",
    taller: "Tokenization Workshop",
    packRwa: "RWA Pack",
    builders: "Tutellus Builders",
    certificaciones: "Tutellus Certifications",
    consultoria: "Tokenization Consulting",
    inversionSegura: "Safe Investment",
    defiAvanzado: "Advanced DeFi",
    club: "Investment Club",
    stakiny: "Stakiny",
    gt3: "GT3",
    dappComposer: "DAPPComposer",
    humanWallet: "HumanWallet",
    comunidad: "Tutellian Community",
    criptoblog: "Criptoblog",
    mafia: "Tutellus Mafia",
  },
  legal: {
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    legalNotice: "Legal Notice",
  },
  copy: "© {{year}} Tutellus.",
}
